export default __webpack_public_path__ + "media/images/icon_blocks-0b0e54d45ff0177b02e1357ac09c0d51.png";